module.exports = __webpack_public_path__ + "media/images/athletes/1425-53a360e414edcaeab9b0f7202cd5d97a.png";